//window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {

    //window.Popper = require('@popperjs/core').default;
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');

    //require('datatables.net');
    //require('datatables.net-responsive/js/dataTables.responsive.min');

} catch (e) {}


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


/**
 * We'll load the datatables library to easily deal w dynamic table frontend
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

 //require('datatables.net/js/jquery.dataTables.min.js')( window, $ );
 //require('datatables.net-responsive/js/dataTables.responsive.min')( window, $ );


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

/**
 * Axios Interceptor for handling 401 and 409 errors
 */
window.axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Redirecionar para a página de login
            window.location.href = '/login';
        } else if (error.response && error.response.status === 419) {
            // CSRF token expirado - dar refresh na página
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

/**
 * Fetch Interceptor for handling 401 and 409 errors
 */
if (typeof window !== 'undefined' && typeof window.fetch !== 'undefined') {
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
        return originalFetch.apply(this, args).then(response => {
            processInterceptors(response);
            return response;
        });
    };
}

/**
 * jQuery Ajax Interceptor for handling 401 and 409 errors
 */
$(document).ajaxError(function(event, jqxhr, settings, thrownError) {
    processInterceptors(jqxhr);
});

function processInterceptors(request) {
    if (request.status === 401) {
        window.location.href = '/login';
    } else if (request.status === 419) {
        // CSRF token expirado - dar refresh na página
        window.location.reload();
    }
}


